import 'bootstrap'
import $ from 'jquery'
import Glide from '@glidejs/glide'

import './style.scss';

document.addEventListener('DOMContentLoaded', () => {
    new Glide('.glide').mount();
});

// Adding Class to contact form 7 form
$(document).ready(function() {
    $('.wpcf7-form-control').not(".wpcf7-submit, .wpcf7-acceptance, .wpcf7-file, .wpcf7-radio").addClass('form-control');
    $('.wpcf7-submit').addClass('btn btn-primary');
});
